/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SAFc Backend
 * The 24/7 API description
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  CreateTicketRequest
} from './sAFcBackend.schemas.js';

import helpdeskControllerCreateTicketMutator from '../response-type.js';
import { customFormData } from '../mutators/custom-file-data.js';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Create helpdesk ticket
 */
export const helpdeskControllerCreateTicket = (
    createTicketRequest: CreateTicketRequest,
 options?: SecondParameter<typeof helpdeskControllerCreateTicketMutator>,signal?: AbortSignal
) => {

      const formData = customFormData(createTicketRequest)
      return helpdeskControllerCreateTicketMutator<void>(
      {url: `/api/helpdesk/ticket`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getHelpdeskControllerCreateTicketMutationKey = () => ['helpdeskControllerCreateTicket'] as const;

export const getHelpdeskControllerCreateTicketMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof helpdeskControllerCreateTicket>>, TError,HelpdeskControllerCreateTicketMutationVariables, TContext>, request?: SecondParameter<typeof helpdeskControllerCreateTicketMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof helpdeskControllerCreateTicket>>, TError,HelpdeskControllerCreateTicketMutationVariables, TContext> => {

const mutationKey = getHelpdeskControllerCreateTicketMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof helpdeskControllerCreateTicket>>, HelpdeskControllerCreateTicketMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  helpdeskControllerCreateTicket(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HelpdeskControllerCreateTicketMutationResult = NonNullable<Awaited<ReturnType<typeof helpdeskControllerCreateTicket>>>
    export type HelpdeskControllerCreateTicketMutationBody = CreateTicketRequest
    export type HelpdeskControllerCreateTicketMutationError = unknown
    export type HelpdeskControllerCreateTicketMutationVariables = {data: CreateTicketRequest}

    export const useHelpdeskControllerCreateTicket = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof helpdeskControllerCreateTicket>>, TError,HelpdeskControllerCreateTicketMutationVariables, TContext>, request?: SecondParameter<typeof helpdeskControllerCreateTicketMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof helpdeskControllerCreateTicket>>,
        TError,
        HelpdeskControllerCreateTicketMutationVariables,
        TContext
      > => {
      return useMutation(getHelpdeskControllerCreateTicketMutationOptions(options), queryClient);
    }
